import { NgIf } from '@angular/common';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Roles } from '@core/modules/role/enums/roles.enum';
import { RoleService } from '@core/modules/role/services/role.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective extends NgIf {
  @Input() set appHasRole(roles: Roles[]) {
    this.ngIf = this.roleService.hasRole(roles);
  }

  @Input() set appHasRoleElse(templateElse: TemplateRef<any>) {
    this.ngIfElse = templateElse;
  }

  @Input('ngIf') set ngIfInput(roles: Roles[]) {
    this.appHasRole = roles;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private roleService: RoleService
  ) {
    super(viewContainerRef, templateRef);
  }
}
